import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';

import { createReducer } from 'utils/redux';

import type {
  CampaignPurchaseOrderAction,
  CampaignPurchaseOrderState
} from '../types';

const EMPTY_STATE: CampaignPurchaseOrderState = {
  result: null
};

const initialState = cloneDeep(EMPTY_STATE);

export default createReducer<CampaignPurchaseOrderState, CampaignPurchaseOrderAction>(
  'campaignPurchaseOrder',
  initialState,
  {
    'purchase-order-fetch': (state, { data }) => produce(
      state, draft => {
        draft.result = data;
      }
    ),
    'purchase-order-add': (state, { data }) => produce(
      state, draft => {
        draft.result = data;
      }
    ),
    'purchase-order-patch': (state, { data }) => produce(
      state, draft => {
        draft.result = data;
      }
    ),
    'purchase-order-delete': (state) => produce(
      state, draft => {
        draft.result = initialState.result;
      }
    ),
    'purchase-order-flush': state => produce(
      state, draft => {
        draft.result = initialState.result;
      }
    )
  }
);
